requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('localization-form')) {
      customElements.define(
        'localization-form',
        class LocalizationForm extends HTMLElement {
          constructor() {
            super();

            this.elements = {
              input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
              button: this.querySelector('button'),
              panel: this.querySelector('ul'),
            };
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

            this.closeSelectorHandler = this.closeSelector.bind(this);
          }

          hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
          }

          onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;

            this.hidePanel();
            this.elements.button.focus();
          }

          onItemClick(event) {
  event.preventDefault();
  const form = this.querySelector('form');
  this.elements.input.value = event.currentTarget.dataset.value;

  if (form) {
    if (this.elements.input.name === 'locale_code') {
      try {
        const section = [...document.querySelectorAll('[id^="shopify-section-"]')]
          .find(el => {
            const rect = el.getBoundingClientRect();
            return rect.top <= 100 && rect.bottom > 100;
          });

        sessionStorage.setItem('bemorrLanguagePosition', JSON.stringify({
          y: window.scrollY,
          section: section ? section.id : null,
          offset: section ? section.getBoundingClientRect().top : 0,
          language: this.elements.input.value,
          time: Date.now()
        }));
      } catch (error) {
        // Dil değiştirme, depolama kullanılamasa da devam eder.
      }
    }

    form.submit();
  }
}


          addBodyHandler() {
            document.body.addEventListener('click', this.closeSelectorHandler);
          }

          removeBodyHandler() {
            document.body.removeEventListener('click', this.closeSelectorHandler);
          }

          openSelector() {
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
            !this.elements.panel.hasAttribute('hidden') ? this.addBodyHandler() : this.removeBodyHandler();
          }

          closeSelector(event) {
            if (!this.contains(event.target)) {
              this.hidePanel();
              this.removeBodyHandler();
            }
          }
        }
      );

      scriptController.scripts.push('localization-form.js');
    }
  });
});
(() => {
  const restorePosition = () => {
    try {
      const key = 'bemorrLanguagePosition';
      const saved = sessionStorage.getItem(key);
      if (!saved) return;

      sessionStorage.removeItem(key);
      const position = JSON.parse(saved);

      if (Date.now() - position.time > 60000) return;
      if (document.documentElement.lang.split('-')[0] !==
          position.language.split('-')[0]) return;

      const section = position.section
        ? document.getElementById(position.section)
        : null;

      const top = section
        ? window.scrollY + section.getBoundingClientRect().top - position.offset
        : position.y;

      window.scrollTo({
        top: Math.max(0, top),
        left: 0,
        behavior: 'instant'
      });
    } catch (error) {
      // Kaydedilmiş konum okunamazsa sayfa normal açılır.
    }
  };

  if (document.readyState === 'complete') {
    requestAnimationFrame(restorePosition);
  } else {
    window.addEventListener('load', () => {
      requestAnimationFrame(restorePosition);
    }, { once: true });
  }
})();
